import type { ReactNode } from 'react';
import React, { useState } from 'react';

const defaultValues: IDefaultValues = {
  isPlpFiltersDrawerOpen: false,
  togglePlpFiltersDrawer: () => {},
  activeFilterAccordion: '',
  setActiveFilterAccordion: () => {},
};

export const PlpContext = React.createContext(defaultValues);

const PlpProvider = ({ children }: { children: ReactNode }) => {
  const [isPlpFiltersDrawerOpen, setIsPlpFiltersDrawerOpen] = useState(false);
  const [activeFilterAccordion, setActiveFilterAccordion] = useState('');

  return (
    <PlpContext.Provider
      value={{
        ...defaultValues,
        isPlpFiltersDrawerOpen,
        activeFilterAccordion,
        togglePlpFiltersDrawer: setIsPlpFiltersDrawerOpen,
        setActiveFilterAccordion,
      }}
    >
      {children}
    </PlpContext.Provider>
  );
};

export default PlpProvider;

interface IDefaultValues {
  isPlpFiltersDrawerOpen: boolean;
  togglePlpFiltersDrawer: (newValue: boolean) => void;
  activeFilterAccordion: string;
  setActiveFilterAccordion: (id: string) => void;
}
